import { useRecoilTransaction_UNSTABLE } from "recoil"

import type { TransactionOperation } from ".."
import { getDragBox } from ".."
import { gatherEdgesWithinBox } from "./gatherWithinBox"
import { useStartDrag } from "./startDrag"
import { startPointState } from "../../../inputs"
import { edgeIndex, findEdgeState } from "../../edges"
import { findNodeState } from "../../nodes"
import { divergeTimeline } from "../../timeline/transactions"
import { designateEdge } from "../designateEdge"

export const finishDragDesignateEdges: TransactionOperation = (transactors) => {
  const dragBox = getDragBox(transactors)
  if (dragBox) {
    const edgeIds = gatherEdgesWithinBox(transactors, {
      box: dragBox,
      edgeStore: [findEdgeState, edgeIndex],
      findPointState: findNodeState,
    })
    const allChanges = edgeIds
      .map((id) => designateEdge(transactors, id))
      .reduce((changes, acc) => [...acc, ...changes], [])
    if (allChanges.length) divergeTimeline(transactors, allChanges)
    transactors.set(startPointState, null)
  }
}

export const useFinishDragDesignateEdges: () => () => void = () =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => finishDragDesignateEdges(transactors),
  )

export const useDragDesignateEdges: () => [VoidFunction, VoidFunction] = () => [
  useStartDrag(),
  useFinishDragDesignateEdges(),
]
